import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import Divider from "components/divider";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import Toggle from "components/form/toggle/Toggle";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    state: IPutTeeSheetSettings;
    updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function CancellationPolicies(props: IProps) {
    const {state, updateState } = props;
    const {t} = useTranslation();

    function handleToggleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { id, checked } = event.target;
        updateState(id as keyof IPutTeeSheetSettings, checked);
      }

      function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { id, value } = event.target;
        updateState(id as keyof IPutTeeSheetSettings, value === "" || Number(value) < 0 ? "" : Number(value));
      }

      return (
        <div className="p-2">
            <FormLayout>
                <FormLayout.Group>
                    <Input
                    value={state.web_cancellation_hours || ""}
                    label={t("Cancellation window")}
                    id="web_cancellation_hours"
                    helpText={t("Cancellations are allowed up to this many hours before tee time")}
                    onChange={handleInputChange}
                    suffix="hours"
                    placeholder={t("Cancellation window")}
                    />
                </FormLayout.Group>
                <FormLayout.Group>
                    <Input
                    value={state.web_edit_hours || ""}
                    label={t("Edit window")}
                    id="web_edit_hours"
                    helpText={t("Changes in bookings are allowed up to this many hours before tee time")}
                    onChange={handleInputChange}
                    suffix="hours"
                    placeholder={t("Edit window")}
                    />
                </FormLayout.Group>
                </FormLayout>
                <Divider/>
                <FormLayout>
                <FormLayout.Group>  
                    <Toggle
                    labelRight={t("Auto charge no show")}
                    id="auto_charge_no_show"
                    checked={!!state.auto_charge_no_show || false}
                    onChange={handleToggleChange}
                    />
                </FormLayout.Group>
            </FormLayout>
        </div>
      );
}